interface CountryCode {
  code: number;
  short: string;
  country: string;
}

export const countryCodeFlag = (code: string) => {
  if (code == "AD") return "🇦🇩";
  if (code == "AE") return "🇦🇪";
  if (code == "AF") return "🇦🇫";
  if (code == "AG") return "🇦🇬";
  if (code == "AI") return "🇦🇮";
  if (code == "AL") return "🇦🇱";
  if (code == "AM") return "🇦🇲";
  if (code == "AO") return "🇦🇴";
  if (code == "AQ") return "🇦🇶";
  if (code == "AR") return "🇦🇷";
  if (code == "AS") return "🇦🇸";
  if (code == "AT") return "🇦🇹";
  if (code == "AU") return "🇦🇺";
  if (code == "AW") return "🇦🇼";
  if (code == "AX") return "🇦🇽";
  if (code == "AZ") return "🇦🇿";
  if (code == "BA") return "🇧🇦";
  if (code == "BB") return "🇧🇧";
  if (code == "BD") return "🇧🇩";
  if (code == "BE") return "🇧🇪";
  if (code == "BF") return "🇧🇫";
  if (code == "BG") return "🇧🇬";
  if (code == "BH") return "🇧🇭";
  if (code == "BI") return "🇧🇮";
  if (code == "BJ") return "🇧🇯";
  if (code == "BL") return "🇧🇱";
  if (code == "BM") return "🇧🇲";
  if (code == "BN") return "🇧🇳";
  if (code == "BO") return "🇧🇴";
  if (code == "BQ") return "🇧🇶";
  if (code == "BR") return "🇧🇷";
  if (code == "BS") return "🇧🇸";
  if (code == "BT") return "🇧🇹";
  if (code == "BV") return "🇧🇻";
  if (code == "BW") return "🇧🇼";
  if (code == "BY") return "🇧🇾";
  if (code == "BZ") return "🇧🇿";
  if (code == "CA") return "🇨🇦";
  if (code == "CC") return "🇨🇨";
  if (code == "CD") return "🇨🇩";
  if (code == "CF") return "🇨🇫";
  if (code == "CG") return "🇨🇬";
  if (code == "CH") return "🇨🇭";
  if (code == "CI") return "🇨🇮";
  if (code == "CK") return "🇨🇰";
  if (code == "CL") return "🇨🇱";
  if (code == "CM") return "🇨🇲";
  if (code == "CN") return "🇨🇳";
  if (code == "CO") return "🇨🇴";
  if (code == "CR") return "🇨🇷";
  if (code == "CU") return "🇨🇺";
  if (code == "CV") return "🇨🇻";
  if (code == "CW") return "🇨🇼";
  if (code == "CX") return "🇨🇽";
  if (code == "CY") return "🇨🇾";
  if (code == "CZ") return "🇨🇿";
  if (code == "DE") return "🇩🇪";
  if (code == "DJ") return "🇩🇯";
  if (code == "DK") return "🇩🇰";
  if (code == "DM") return "🇩🇲";
  if (code == "DO") return "🇩🇴";
  if (code == "DZ") return "🇩🇿";
  if (code == "EC") return "🇪🇨";
  if (code == "EE") return "🇪🇪";
  if (code == "EG") return "🇪🇬";
  if (code == "EH") return "🇪🇭";
  if (code == "ER") return "🇪🇷";
  if (code == "ES") return "🇪🇸";
  if (code == "ET") return "🇪🇹";
  if (code == "FI") return "🇫🇮";
  if (code == "FJ") return "🇫🇯";
  if (code == "FK") return "🇫🇰";
  if (code == "FM") return "🇫🇲";
  if (code == "FO") return "🇫🇴";
  if (code == "FR") return "🇫🇷";
  if (code == "GA") return "🇬🇦";
  if (code == "GB") return "🇬🇧";
  if (code == "GD") return "🇬🇩";
  if (code == "GE") return "🇬🇪";
  if (code == "GF") return "🇬🇫";
  if (code == "GG") return "🇬🇬";
  if (code == "GH") return "🇬🇭";
  if (code == "GI") return "🇬🇮";
  if (code == "GL") return "🇬🇱";
  if (code == "GM") return "🇬🇲";
  if (code == "GN") return "🇬🇳";
  if (code == "GP") return "🇬🇵";
  if (code == "GQ") return "🇬🇶";
  if (code == "GR") return "🇬🇷";
  if (code == "GS") return "🇬🇸";
  if (code == "GT") return "🇬🇹";
  if (code == "GU") return "🇬🇺";
  if (code == "GW") return "🇬🇼";
  if (code == "GY") return "🇬🇾";
  if (code == "HK") return "🇭🇰";
  if (code == "HM") return "🇭🇲";
  if (code == "HN") return "🇭🇳";
  if (code == "HR") return "🇭🇷";
  if (code == "HT") return "🇭🇹";
  if (code == "HU") return "🇭🇺";
  if (code == "ID") return "🇮🇩";
  if (code == "IE") return "🇮🇪";
  if (code == "IL") return "🇮🇱";
  if (code == "IM") return "🇮🇲";
  if (code == "IN") return "🇮🇳";
  if (code == "IO") return "🇮🇴";
  if (code == "IQ") return "🇮🇶";
  if (code == "IR") return "🇮🇷";
  if (code == "IS") return "🇮🇸";
  if (code == "IT") return "🇮🇹";
  if (code == "JE") return "🇯🇪";
  if (code == "JM") return "🇯🇲";
  if (code == "JO") return "🇯🇴";
  if (code == "JP") return "🇯🇵";
  if (code == "KE") return "🇰🇪";
  if (code == "KG") return "🇰🇬";
  if (code == "KH") return "🇰🇭";
  if (code == "KI") return "🇰🇮";
  if (code == "KM") return "🇰🇲";
  if (code == "KN") return "🇰🇳";
  if (code == "KP") return "🇰🇵";
  if (code == "KR") return "🇰🇷";
  if (code == "KW") return "🇰🇼";
  if (code == "KY") return "🇰🇾";
  if (code == "KZ") return "🇰🇿";
  if (code == "LA") return "🇱🇦";
  if (code == "LB") return "🇱🇧";
  if (code == "LC") return "🇱🇨";
  if (code == "LI") return "🇱🇮";
  if (code == "LK") return "🇱🇰";
  if (code == "LR") return "🇱🇷";
  if (code == "LS") return "🇱🇸";
  if (code == "LT") return "🇱🇹";
  if (code == "LU") return "🇱🇺";
  if (code == "LV") return "🇱🇻";
  if (code == "LY") return "🇱🇾";
  if (code == "MA") return "🇲🇦";
  if (code == "MC") return "🇲🇨";
  if (code == "MD") return "🇲🇩";
  if (code == "ME") return "🇲🇪";
  if (code == "MF") return "🇲🇫";
  if (code == "MG") return "🇲🇬";
  if (code == "MH") return "🇲🇭";
  if (code == "MK") return "🇲🇰";
  if (code == "ML") return "🇲🇱";
  if (code == "MM") return "🇲🇲";
  if (code == "MN") return "🇲🇳";
  if (code == "MO") return "🇲🇴";
  if (code == "MP") return "🇲🇵";
  if (code == "MQ") return "🇲🇶";
  if (code == "MR") return "🇲🇷";
  if (code == "MS") return "🇲🇸";
  if (code == "MT") return "🇲🇹";
  if (code == "MU") return "🇲🇺";
  if (code == "MV") return "🇲🇻";
  if (code == "MW") return "🇲🇼";
  if (code == "MX") return "🇲🇽";
  if (code == "MY") return "🇲🇾";
  if (code == "MZ") return "🇲🇿";
  if (code == "NA") return "🇳🇦";
  if (code == "NC") return "🇳🇨";
  if (code == "NE") return "🇳🇪";
  if (code == "NF") return "🇳🇫";
  if (code == "NG") return "🇳🇬";
  if (code == "NI") return "🇳🇮";
  if (code == "NL") return "🇳🇱";
  if (code == "NO") return "🇳🇴";
  if (code == "NP") return "🇳🇵";
  if (code == "NR") return "🇳🇷";
  if (code == "NU") return "🇳🇺";
  if (code == "NZ") return "🇳🇿";
  if (code == "OM") return "🇴🇲";
  if (code == "PA") return "🇵🇦";
  if (code == "PE") return "🇵🇪";
  if (code == "PF") return "🇵🇫";
  if (code == "PG") return "🇵🇬";
  if (code == "PH") return "🇵🇭";
  if (code == "PK") return "🇵🇰";
  if (code == "PL") return "🇵🇱";
  if (code == "PM") return "🇵🇲";
  if (code == "PN") return "🇵🇳";
  if (code == "PR") return "🇵🇷";
  if (code == "PS") return "🇵🇸";
  if (code == "PT") return "🇵🇹";
  if (code == "PW") return "🇵🇼";
  if (code == "PY") return "🇵🇾";
  if (code == "QA") return "🇶🇦";
  if (code == "RE") return "🇷🇪";
  if (code == "RO") return "🇷🇴";
  if (code == "RS") return "🇷🇸";
  if (code == "RU") return "🇷🇺";
  if (code == "RW") return "🇷🇼";
  if (code == "SA") return "🇸🇦";
  if (code == "SB") return "🇸🇧";
  if (code == "SC") return "🇸🇨";
  if (code == "SD") return "🇸🇩";
  if (code == "SE") return "🇸🇪";
  if (code == "SG") return "🇸🇬";
  if (code == "SH") return "🇸🇭";
  if (code == "SI") return "🇸🇮";
  if (code == "SJ") return "🇸🇯";
  if (code == "SK") return "🇸🇰";
  if (code == "SL") return "🇸🇱";
  if (code == "SM") return "🇸🇲";
  if (code == "SN") return "🇸🇳";
  if (code == "SO") return "🇸🇴";
  if (code == "SR") return "🇸🇷";
  if (code == "SS") return "🇸🇸";
  if (code == "ST") return "🇸🇹";
  if (code == "SV") return "🇸🇻";
  if (code == "SX") return "🇸🇽";
  if (code == "SY") return "🇸🇾";
  if (code == "SZ") return "🇸🇿";
  if (code == "TC") return "🇹🇨";
  if (code == "TD") return "🇹🇩";
  if (code == "TF") return "🇹🇫";
  if (code == "TG") return "🇹🇬";
  if (code == "TH") return "🇹🇭";
  if (code == "TJ") return "🇹🇯";
  if (code == "TK") return "🇹🇰";
  if (code == "TL") return "🇹🇱";
  if (code == "TM") return "🇹🇲";
  if (code == "TN") return "🇹🇳";
  if (code == "TO") return "🇹🇴";
  if (code == "TR") return "🇹🇷";
  if (code == "TT") return "🇹🇹";
  if (code == "TV") return "🇹🇻";
  if (code == "TW") return "🇹🇼";
  if (code == "TZ") return "🇹🇿";
  if (code == "UA") return "🇺🇦";
  if (code == "UG") return "🇺🇬";
  if (code == "UM") return "🇺🇲";
  if (code == "US") return "🇺🇸";
  if (code == "UY") return "🇺🇾";
  if (code == "UZ") return "🇺🇿";
  if (code == "VA") return "🇻🇦";
  if (code == "VC") return "🇻🇨";
  if (code == "VE") return "🇻🇪";
  if (code == "VG") return "🇻🇬";
  if (code == "VI") return "🇻🇮";
  if (code == "VN") return "🇻🇳";
  if (code == "VU") return "🇻🇺";
  if (code == "WF") return "🇼🇫";
  if (code == "WS") return "🇼🇸";
  if (code == "XK") return "🇽🇰";
  if (code == "YE") return "🇾🇪";
  if (code == "YT") return "🇾🇹";
  if (code == "ZA") return "🇿🇦";
  if (code == "ZM") return "🇿🇲";
  return "🏳";
};

export const countryCodes: CountryCode[] = [
  {
    short: "AF",
    code: 93,
    country: "Afghanistan",
  },
  {
    short: "AL",
    code: 355,
    country: "Albania",
  },
  {
    short: "DZ",
    code: 213,
    country: "Algeria",
  },
  {
    short: "AD",
    code: 376,
    country: "Andorra",
  },
  {
    short: "AO",
    code: 244,
    country: "Angola",
  },
  {
    short: "AQ",
    code: 672,
    country: "Antarctica",
  },
  {
    short: "AR",
    code: 54,
    country: "Argentina",
  },
  {
    short: "AM",
    code: 374,
    country: "Armenia",
  },
  {
    short: "AW",
    code: 297,
    country: "Aruba",
  },
  {
    short: "AU",
    code: 61,
    country: "Australia",
  },
  {
    short: "AT",
    code: 43,
    country: "Austria",
  },
  {
    short: "AZ",
    code: 994,
    country: "Azerbaijan",
  },
  {
    short: "BH",
    code: 973,
    country: "Bahrain",
  },
  {
    short: "BD",
    code: 880,
    country: "Bangladesh",
  },
  {
    short: "BY",
    code: 375,
    country: "Belarus",
  },
  {
    short: "BE",
    code: 32,
    country: "Belgium",
  },
  {
    short: "BZ",
    code: 501,
    country: "Belize",
  },
  {
    short: "BJ",
    code: 229,
    country: "Benin",
  },
  {
    short: "BT",
    code: 975,
    country: "Bhutan",
  },
  {
    short: "BO",
    code: 591,
    country: "Bolivia",
  },
  {
    short: "BA",
    code: 387,
    country: "Bosnia and Herzegovina",
  },
  {
    short: "BW",
    code: 267,
    country: "Botswana",
  },
  {
    short: "BR",
    code: 55,
    country: "Brazil",
  },
  {
    short: "IO",
    code: 246,
    country: "British Indian Ocean Territory",
  },
  {
    short: "BN",
    code: 673,
    country: "Brunei",
  },
  {
    short: "BG",
    code: 359,
    country: "Bulgaria",
  },
  {
    short: "BF",
    code: 226,
    country: "Burkina Faso",
  },
  {
    short: "BI",
    code: 257,
    country: "Burundi",
  },
  {
    short: "KH",
    code: 855,
    country: "Cambodia",
  },
  {
    short: "CM",
    code: 237,
    country: "Cameroon",
  },
  {
    short: "CA",
    code: 1,
    country: "Canada",
  },
  {
    short: "CV",
    code: 238,
    country: "Cape Verde",
  },
  {
    short: "CF",
    code: 236,
    country: "Central African Republic",
  },
  {
    short: "TD",
    code: 235,
    country: "Chad",
  },
  {
    short: "CL",
    code: 56,
    country: "Chile",
  },
  {
    short: "CN",
    code: 86,
    country: "China",
  },
  {
    short: "CX",
    code: 61,
    country: "Christmas Island",
  },
  {
    short: "CC",
    code: 61,
    country: "Cocos Islands",
  },
  {
    short: "CO",
    code: 57,
    country: "Colombia",
  },
  {
    short: "KM",
    code: 269,
    country: "Comoros",
  },
  {
    short: "CK",
    code: 682,
    country: "Cook Islands",
  },
  {
    short: "CR",
    code: 506,
    country: "Costa Rica",
  },
  {
    short: "HR",
    code: 385,
    country: "Croatia",
  },
  {
    short: "CU",
    code: 53,
    country: "Cuba",
  },
  {
    short: "CW",
    code: 599,
    country: "Curacao",
  },
  {
    short: "CY",
    code: 357,
    country: "Cyprus",
  },
  {
    short: "CZ",
    code: 420,
    country: "Czech Republic",
  },
  {
    short: "CD",
    code: 243,
    country: "Democratic Republic of the Congo",
  },
  {
    short: "DK",
    code: 45,
    country: "Denmark",
  },
  {
    short: "DJ",
    code: 253,
    country: "Djibouti",
  },
  {
    short: "TL",
    code: 670,
    country: "East Timor",
  },
  {
    short: "EC",
    code: 593,
    country: "Ecuador",
  },
  {
    short: "EG",
    code: 20,
    country: "Egypt",
  },
  {
    short: "SV",
    code: 503,
    country: "El Salvador",
  },
  {
    short: "GQ",
    code: 240,
    country: "Equatorial Guinea",
  },
  {
    short: "ER",
    code: 291,
    country: "Eritrea",
  },
  {
    short: "EE",
    code: 372,
    country: "Estonia",
  },
  {
    short: "ET",
    code: 251,
    country: "Ethiopia",
  },
  {
    short: "FK",
    code: 500,
    country: "Falkland Islands",
  },
  {
    short: "FO",
    code: 298,
    country: "Faroe Islands",
  },
  {
    short: "FJ",
    code: 679,
    country: "Fiji",
  },
  {
    short: "FI",
    code: 358,
    country: "Finland",
  },
  {
    short: "FR",
    code: 33,
    country: "France",
  },
  {
    short: "PF",
    code: 689,
    country: "French Polynesia",
  },
  {
    short: "GA",
    code: 241,
    country: "Gabon",
  },
  {
    short: "GM",
    code: 220,
    country: "Gambia",
  },
  {
    short: "GE",
    code: 995,
    country: "Georgia",
  },
  {
    short: "DE",
    code: 49,
    country: "Germany",
  },
  {
    short: "GH",
    code: 233,
    country: "Ghana",
  },
  {
    short: "GI",
    code: 350,
    country: "Gibraltar",
  },
  {
    short: "GR",
    code: 30,
    country: "Greece",
  },
  {
    short: "GL",
    code: 299,
    country: "Greenland",
  },
  {
    short: "GT",
    code: 502,
    country: "Guatemala",
  },
  {
    short: "GN",
    code: 224,
    country: "Guinea",
  },
  {
    short: "GW",
    code: 245,
    country: "Guinea-Bissau",
  },
  {
    short: "GY",
    code: 592,
    country: "Guyana",
  },
  {
    short: "HT",
    code: 509,
    country: "Haiti",
  },
  {
    short: "HN",
    code: 504,
    country: "Honduras",
  },
  {
    short: "HK",
    code: 852,
    country: "Hong Kong",
  },
  {
    short: "HU",
    code: 36,
    country: "Hungary",
  },
  {
    short: "IS",
    code: 354,
    country: "Iceland",
  },
  {
    short: "IN",
    code: 91,
    country: "India",
  },
  {
    short: "ID",
    code: 62,
    country: "Indonesia",
  },
  {
    short: "IR",
    code: 98,
    country: "Iran",
  },
  {
    short: "IQ",
    code: 964,
    country: "Iraq",
  },
  {
    short: "IE",
    code: 353,
    country: "Ireland",
  },
  {
    short: "IL",
    code: 972,
    country: "Israel",
  },
  {
    short: "IT",
    code: 39,
    country: "Italy",
  },
  {
    short: "CI",
    code: 225,
    country: "Ivory Coast",
  },
  {
    short: "JP",
    code: 81,
    country: "Japan",
  },
  {
    short: "JO",
    code: 962,
    country: "Jordan",
  },
  {
    short: "KZ",
    code: 7,
    country: "Kazakhstan",
  },
  {
    short: "KE",
    code: 254,
    country: "Kenya",
  },
  {
    short: "KI",
    code: 686,
    country: "Kiribati",
  },
  {
    short: "XK",
    code: 383,
    country: "Kosovo",
  },
  {
    short: "KW",
    code: 965,
    country: "Kuwait",
  },
  {
    short: "KG",
    code: 996,
    country: "Kyrgyzstan",
  },
  {
    short: "LA",
    code: 856,
    country: "Laos",
  },
  {
    short: "LV",
    code: 371,
    country: "Latvia",
  },
  {
    short: "LB",
    code: 961,
    country: "Lebanon",
  },
  {
    short: "LS",
    code: 266,
    country: "Lesotho",
  },
  {
    short: "LR",
    code: 231,
    country: "Liberia",
  },
  {
    short: "LY",
    code: 218,
    country: "Libya",
  },
  {
    short: "LI",
    code: 423,
    country: "Liechtenstein",
  },
  {
    short: "LT",
    code: 370,
    country: "Lithuania",
  },
  {
    short: "LU",
    code: 352,
    country: "Luxembourg",
  },
  {
    short: "MO",
    code: 853,
    country: "Macau",
  },
  {
    short: "MK",
    code: 389,
    country: "Macedonia",
  },
  {
    short: "MG",
    code: 261,
    country: "Madagascar",
  },
  {
    short: "MW",
    code: 265,
    country: "Malawi",
  },
  {
    short: "MY",
    code: 60,
    country: "Malaysia",
  },
  {
    short: "MV",
    code: 960,
    country: "Maldives",
  },
  {
    short: "ML",
    code: 223,
    country: "Mali",
  },
  {
    short: "MT",
    code: 356,
    country: "Malta",
  },
  {
    short: "MH",
    code: 692,
    country: "Marshall Islands",
  },
  {
    short: "MR",
    code: 222,
    country: "Mauritania",
  },
  {
    short: "MU",
    code: 230,
    country: "Mauritius",
  },
  {
    short: "YT",
    code: 262,
    country: "Mayotte",
  },
  {
    short: "MX",
    code: 52,
    country: "Mexico",
  },
  {
    short: "FM",
    code: 691,
    country: "Micronesia",
  },
  {
    short: "MD",
    code: 373,
    country: "Moldova",
  },
  {
    short: "MC",
    code: 377,
    country: "Monaco",
  },
  {
    short: "MN",
    code: 976,
    country: "Mongolia",
  },
  {
    short: "ME",
    code: 382,
    country: "Montenegro",
  },
  {
    short: "MA",
    code: 212,
    country: "Morocco",
  },
  {
    short: "MZ",
    code: 258,
    country: "Mozambique",
  },
  {
    short: "MM",
    code: 95,
    country: "Myanmar",
  },
  {
    short: "NA",
    code: 264,
    country: "Namibia",
  },
  {
    short: "NR",
    code: 674,
    country: "Nauru",
  },
  {
    short: "NP",
    code: 977,
    country: "Nepal",
  },
  {
    short: "NL",
    code: 31,
    country: "Netherlands",
  },
  {
    short: "AN",
    code: 599,
    country: "Netherlands Antilles",
  },
  {
    short: "NC",
    code: 687,
    country: "New Caledonia",
  },
  {
    short: "NZ",
    code: 64,
    country: "New Zealand",
  },
  {
    short: "NI",
    code: 505,
    country: "Nicaragua",
  },
  {
    short: "NE",
    code: 227,
    country: "Niger",
  },
  {
    short: "NG",
    code: 234,
    country: "Nigeria",
  },
  {
    short: "NU",
    code: 683,
    country: "Niue",
  },
  {
    short: "KP",
    code: 850,
    country: "North Korea",
  },
  {
    short: "NO",
    code: 47,
    country: "Norway",
  },
  {
    short: "OM",
    code: 968,
    country: "Oman",
  },
  {
    short: "PK",
    code: 92,
    country: "Pakistan",
  },
  {
    short: "PW",
    code: 680,
    country: "Palau",
  },
  {
    short: "PS",
    code: 970,
    country: "Palestine",
  },
  {
    short: "PA",
    code: 507,
    country: "Panama",
  },
  {
    short: "PG",
    code: 675,
    country: "Papua New Guinea",
  },
  {
    short: "PY",
    code: 595,
    country: "Paraguay",
  },
  {
    short: "PE",
    code: 51,
    country: "Peru",
  },
  {
    short: "PH",
    code: 63,
    country: "Philippines",
  },
  {
    short: "PN",
    code: 64,
    country: "Pitcairn",
  },
  {
    short: "PL",
    code: 48,
    country: "Poland",
  },
  {
    short: "PT",
    code: 351,
    country: "Portugal",
  },
  {
    short: "QA",
    code: 974,
    country: "Qatar",
  },
  {
    short: "CG",
    code: 242,
    country: "Republic of the Congo",
  },
  {
    short: "RE",
    code: 262,
    country: "Reunion",
  },
  {
    short: "RO",
    code: 40,
    country: "Romania",
  },
  {
    short: "RU",
    code: 7,
    country: "Russia",
  },
  {
    short: "RW",
    code: 250,
    country: "Rwanda",
  },
  {
    short: "BL",
    code: 590,
    country: "Saint Barthelemy",
  },
  {
    short: "SH",
    code: 290,
    country: "Saint Helena",
  },
  {
    short: "MF",
    code: 590,
    country: "Saint Martin",
  },
  {
    short: "PM",
    code: 508,
    country: "Saint Pierre and Miquelon",
  },
  {
    short: "WS",
    code: 685,
    country: "Samoa",
  },
  {
    short: "SM",
    code: 378,
    country: "San Marino",
  },
  {
    short: "ST",
    code: 239,
    country: "Sao Tome and Principe",
  },
  {
    short: "SA",
    code: 966,
    country: "Saudi Arabia",
  },
  {
    short: "SN",
    code: 221,
    country: "Senegal",
  },
  {
    short: "RS",
    code: 381,
    country: "Serbia",
  },
  {
    short: "SC",
    code: 248,
    country: "Seychelles",
  },
  {
    short: "SL",
    code: 232,
    country: "Sierra Leone",
  },
  {
    short: "SG",
    code: 65,
    country: "Singapore",
  },
  {
    short: "SK",
    code: 421,
    country: "Slovakia",
  },
  {
    short: "SI",
    code: 386,
    country: "Slovenia",
  },
  {
    short: "SB",
    code: 677,
    country: "Solomon Islands",
  },
  {
    short: "SO",
    code: 252,
    country: "Somalia",
  },
  {
    short: "ZA",
    code: 27,
    country: "South Africa",
  },
  {
    short: "KR",
    code: 82,
    country: "South Korea",
  },
  {
    short: "SS",
    code: 211,
    country: "South Sudan",
  },
  {
    short: "ES",
    code: 34,
    country: "Spain",
  },
  {
    short: "LK",
    code: 94,
    country: "Sri Lanka",
  },
  {
    short: "SD",
    code: 249,
    country: "Sudan",
  },
  {
    short: "SR",
    code: 597,
    country: "Suriname",
  },
  {
    short: "SJ",
    code: 47,
    country: "Svalbard and Jan Mayen",
  },
  {
    short: "SZ",
    code: 268,
    country: "Swaziland",
  },
  {
    short: "SE",
    code: 46,
    country: "Sweden",
  },
  {
    short: "CH",
    code: 41,
    country: "Switzerland",
  },
  {
    short: "SY",
    code: 963,
    country: "Syria",
  },
  {
    short: "TW",
    code: 886,
    country: "Taiwan",
  },
  {
    short: "TJ",
    code: 992,
    country: "Tajikistan",
  },
  {
    short: "TZ",
    code: 255,
    country: "Tanzania",
  },
  {
    short: "TH",
    code: 66,
    country: "Thailand",
  },
  {
    short: "TG",
    code: 228,
    country: "Togo",
  },
  {
    short: "TK",
    code: 690,
    country: "Tokelau",
  },
  {
    short: "TO",
    code: 676,
    country: "Tonga",
  },
  {
    short: "TN",
    code: 216,
    country: "Tunisia",
  },
  {
    short: "TR",
    code: 90,
    country: "Turkey",
  },
  {
    short: "TM",
    code: 993,
    country: "Turkmenistan",
  },
  {
    short: "TV",
    code: 688,
    country: "Tuvalu",
  },
  {
    short: "UG",
    code: 256,
    country: "Uganda",
  },
  {
    short: "UA",
    code: 380,
    country: "Ukraine",
  },
  {
    short: "AE",
    code: 971,
    country: "United Arab Emirates",
  },
  {
    short: "GB",
    code: 44,
    country: "United Kingdom",
  },
  {
    short: "US",
    code: 1,
    country: "United States",
  },
  {
    short: "UY",
    code: 598,
    country: "Uruguay",
  },
  {
    short: "UZ",
    code: 998,
    country: "Uzbekistan",
  },
  {
    short: "VU",
    code: 678,
    country: "Vanuatu",
  },
  {
    short: "VA",
    code: 379,
    country: "Vatican",
  },
  {
    short: "VE",
    code: 58,
    country: "Venezuela",
  },
  {
    short: "VN",
    code: 84,
    country: "Vietnam",
  },
  {
    short: "WF",
    code: 681,
    country: "Wallis and Futuna",
  },
  {
    short: "EH",
    code: 212,
    country: "Western Sahara",
  },
  {
    short: "YE",
    code: 967,
    country: "Yemen",
  },
  {
    short: "ZM",
    code: 260,
    country: "Zambia",
  },
  {
    short: "ZW",
    code: 263,
    country: "Zimbabwe",
  },
];
